<template>
	<div class="popup popup--mini" @mousedown.self="$emit('close')">
		<div class="popup__block">
			<div class="popup__top">
				<div class="popup__title">Изменить место доставки</div>
				<div class="popup__close" @click="$emit('close')"></div>
			</div>
			<div class="popup__content">
				<div class="popup__form">
					<InputSelect>
						<template #select>
							<Multiselect
								:can-clear="false"
								:canDeselect="false"
								:noResultsText="'Ничего не найдено'"
								:options="options"
								v-model="value"
								:label="'name'"
								:value-prop="'id'"
								:placeholder="'Выберите способ доставки'"
								/>
						</template>
					</InputSelect>
				</div>
				<div class="popup__btns">
					<button class="btn btn--color" :disabled="!value" @click="handleSubmit">Применить</button>
					<button class="btn btn--border" @click="$emit('close')">Отмена</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

import InputSelect from "@/components/base/utils/formElements/InputSelect.vue";
import Multiselect from "@vueform/multiselect/src/Multiselect";
export default {
	name: "EditDeliveryPlacePopup",
	components: {InputSelect, Multiselect},
	emits: ['close'],
	props: {
		id: {
			type: [String, Number],
			required: true
		},
		options: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			value: null
		}
	},
	computed: {
		...mapGetters({
			getOffersKey: "tenders/getOffersKey",
		})
	},
	mounted() {
		this.value = this.getOffersKey({id: this.id, key: 'deliveryDestination'});
	},
	methods: {
		handleSubmit() {
			this.updateOffersKey({id: this.id, key: 'deliveryDestination', value: this.value});
			this.$emit('close');
		},
		...mapActions({
			updateOffersKey: 'tenders/updateOffersKey',
		})
	}
}
</script>


